import { render, staticRenderFns } from "./ProductPlace.vue?vue&type=template&id=1b9a9abe&"
import script from "./ProductPlace.vue?vue&type=script&lang=js&"
export * from "./ProductPlace.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlace.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports